/**
 * Welcome Screen Component
 */

import React, { useState } from "react";
import { useLiveAPIContext } from "../../contexts/LiveAPIContext";
import { useMobileDetection } from "../../hooks/use-mobile-detection";
import { Button } from "../ui/Button";
import { MobileConnectionHelper } from "../mobile/MobileConnectionHelper";
import "./WelcomeScreen.scss";

export const WelcomeScreen: React.FC = () => {
  const { connected, connect } = useLiveAPIContext();
  const { isMobile } = useMobileDetection();
  const [showMobileHelper, setShowMobileHelper] = useState(false);

  if (connected) return null;

  return (
    <div className="welcome-screen">
      <div className="welcome-content">
        <div className="getting-started">
          <h2>Ready to get started?</h2>
          <p>Connect to the Live API to begin your multimodal AI experience</p>

          <div className="connect-actions">
            <Button
              variant="primary"
              size="lg"
              onClick={connect}
              leftIcon={
                <span className="material-symbols-outlined">play_arrow</span>
              }
              className="connect-button"
            >
              Connect to Live API
            </Button>

            {isMobile && (
              <Button
                variant="secondary"
                size="md"
                onClick={() => setShowMobileHelper(true)}
                leftIcon={
                  <span className="material-symbols-outlined">help</span>
                }
                className="mobile-help-button"
              >
                Mobile Setup Help
              </Button>
            )}
          </div>
        </div>

        <div className="quick-tips">
          <h3>Quick Tips:</h3>
          <ul>
            <li>
              🎯 <strong>Click Connect</strong> to start your AI conversation
            </li>
            <li>
              🎤 <strong>Use the microphone</strong> for voice interactions
            </li>
            <li>
              📱 <strong>Try screen sharing</strong> to show the AI what you're
              working on
            </li>
            <li>
              📝 <strong>Check the console</strong> to see conversation logs and
              debug info
            </li>
          </ul>
        </div>
      </div>

      <MobileConnectionHelper
        isVisible={showMobileHelper}
        onClose={() => setShowMobileHelper(false)}
      />
    </div>
  );
};
